import { SDK_Colors } from "@quickpoint.me/shared";
import { FilterInterface } from "../@types/viewerati";

let colors: SDK_Colors;

function interpolateColors(filter: FilterInterface): FilterInterface {
  if (!filter) return filter;
  if (filter.colors) colors = filter.colors;
  // list of filter modifiers that define colors
  const coloredModifiers = [
    "background",
    "backgroundColor",
    "borderColor",
    "color",
    "markerColor",
  ];
  for (const [key, value] of Object.entries(filter)) {
    const v = value as keyof SDK_Colors;
    const k = key as keyof FilterInterface;

    if (coloredModifiers.includes(k) && colors[v]) {
      // @ts-expect-error: difficult typings
      filter[k] = colors[v];
    }
    // recurse if it's a filter for an element
    if (filter[k] && typeof filter[k] === "object") {
      // @ts-expect-error: difficult typings
      interpolateColors(filter[k]);
    }
  }
  return filter;
}

export default interpolateColors;
